module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-60.b8cf1aa2.svg";